import React, { useEffect, useState } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";
import { Field, Form, Formik, useFormikContext } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { isAfter, parse, isValid, isBefore, isEqual, format } from "date-fns";

import {
  Flex,
  Text,
  Button,
  FormControl,
  FormErrorMessage,
  Box,
} from "@chakra-ui/react";

import { Identificacao } from "./Identificacao";
import { Filiacao } from "./Filiacao";
import { Movimentacao } from "./Movimentacao";
import { FamiliaAcolhedora } from "./FamiliaAcolhedora";

import CriancaService from "../../../../main/services/CriancaService";
import FamiliaAcolhedoraSAService from "../../../../main/services/FamiliaAcolhedoraSAService";
import MovimentacaoService from "../../../../main/services/MovimentacaoService";
import { getBase64 } from "../../../components/Base64";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { isValidCPF } from "../../../utils/isValidCPF";
import { useAuth } from "react-oidc-context";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { criancaFunc } from "../../../../helpers/Funcionalidades";

export const CadastrarCrianca = () => {
  const history = useHistory();
  const { id } = useParams();
  const keycloak = useAuth();

  const { roleKeycloack, user } = useAuthProvider();

  const [dataMenor, setDataMenor] = useState(false);
  const [dataFutura, setDataFutura] = useState(false);
  const [dataFuturaFoto, setDataFuturaFoto] = useState(false);
  const [dataNascimentoFuturaFamilia, setDataNascimentoFuturaFamilia] =
    useState();
  const [dataMenorFoto, setDataMenorFoto] = useState(false);
  const { idPessoaFisicaFilho, setIdPessoaFisicaFilho, irmaoCadatrar } =
    useAppContext();
  const [removeu, setRemoveu] = useState(false);
  const [invalidCPF, setInvalidCPF] = useState(false);
  const [messageValid, setMessageValid] = useState("");
  const location = useLocation();
  const origemAcao = new URLSearchParams(location.search).get("acao");

  const suportedImageFormats = [
    "image/jpg",
    "image/jpeg",
    "image/tiff",
    "image/png",
    "image/bmp",
  ];
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  useEffect(() => {
    if (!irmaoCadatrar || !origemAcao) {
      setIdPessoaFisicaFilho(null);
    }
  }, [setIdPessoaFisicaFilho, irmaoCadatrar, origemAcao]);

  const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
      if (isSubmitting && !isValidating) {
        let keys = Object.keys(errors);
        if (keys.length > 0) {
          const selector = `[name=${keys[0]}]`;
          const errorElement = document.querySelector(selector);
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            errorElement.focus({ preventScroll: true });
          }
        }
      }
    }, [errors, isSubmitting, isValidating]);

    return null;
  };

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const {
          dataNascimento,
          dataMovimentacao,
          dataFoto,
          cpfFamiliaAcolhedora,
          dataNascimentoFamiliaAcolhedora,
        } = values;
        const currentDate = new Date();

        if (dataMovimentacao) {
          const movementDate = parse(
            dataMovimentacao,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
            setDataMenor(false);
          } else {
            setDataFutura(false);
          }
        }

        if (dataNascimentoFamiliaAcolhedora) {
          const movementDate = parse(
            dataNascimentoFamiliaAcolhedora,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataNascimentoFuturaFamilia(true);
          } else {
            setDataNascimentoFuturaFamilia(false);
          }
        }

        if (dataFoto) {
          const movementDate = parse(dataFoto, "dd/MM/yyyy", new Date());
          if (isAfter(movementDate, currentDate)) {
            setDataFuturaFoto(true);
          } else {
            setDataFuturaFoto(false);
          }
        }

        if (dataNascimento && dataFoto) {
          const birthDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
          const movementDate = parse(dataFoto, "dd/MM/yyyy", new Date());

          if (
            isBefore(movementDate, birthDate) &&
            !isAfter(movementDate, currentDate)
          ) {
            setDataMenorFoto(true);
          } else {
            setDataMenorFoto(false);
          }
        }

        if (dataNascimento && dataMovimentacao) {
          const birthDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
          const movementDate = parse(
            dataMovimentacao,
            "dd/MM/yyyy",
            new Date()
          );

          if (
            isBefore(movementDate, birthDate) &&
            !isAfter(movementDate, currentDate)
          ) {
            setDataMenor(true);
          } else {
            setDataMenor(false);
          }
        }
        if (cpfFamiliaAcolhedora) {
          if (isValidCPF(cpfFamiliaAcolhedora)) {
            setInvalidCPF(true);
            setFieldError("cpfFamiliaAcolhedora", "");
          } else {
            setInvalidCPF(false);
            setFieldError("cpfFamiliaAcolhedora", "");
          }
        }
      };

      validateDate();
    }, [
      values,
      values.dataNascimento,
      values.dataMovimentacao,
      values.dataFoto,
      setFieldError,
    ]);

    return null;
  };

  const FocusErrorDuplicidade = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      const validateDateDuplicidade = () => {
        const { dataNascimento, idGenero, nome, nomeSocial, nomeNaoInformado } =
          values;

        const valuesToSendValid = {
          nome: nome ? nome.trim() : "",
          nomeSocial: nomeSocial ? nomeSocial.trim() : "",
          idGenero: idGenero ? idGenero.id : "",
          indicadorNomeNaoInformado:
            nomeNaoInformado?.includes("Possui") || nomeNaoInformado === "S"
              ? "S"
              : "N",
          idCrianca: null,
          nomeUsuarioLogado: `${
            !!keycloak.user.profile?.name ? keycloak.user.profile?.name : ""
          }`,

          dataNascimento:
            dataNascimento &&
            dataNascimento.length === 10 &&
            isValid(parse(dataNascimento, "dd/MM/yyyy", new Date()))
              ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
              : "",
        };

        if (
          dataNascimento &&
          dataNascimento.length === 10 &&
          idGenero &&
          ((nome && nome.length > 0) || (nomeSocial && nomeSocial.length > 0))
        ) {
          CriancaService.validCrianca(valuesToSendValid).catch((error) => {
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message,
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then(() => {
              history.push(`/crianca`);
            });
          });
        }
      };

      validateDateDuplicidade();
    }, [
      values,
      values.dataNascimento,
      values.idGenero,
      values.nome,
      values.nomeSocial,
      values.nomeNaoInformado,
    ]);

    return null;
  };

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  const backAlert = () => {
    if (!roleKeycloack.includes(criancaFunc.cadastrar)) {
      history.goBack();
    } else {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          history.goBack();
        }
      });
    }
  };

  const schema = Yup.object().shape(
    {
      foto: Yup.mixed()
        .nullable()
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (value === null) {
            return true;
          } else {
            return value.size <= 10000000;
          }
        })
        .test("imageType", "Anexar uma extensão válida.", (value) => {
          if (value === null) {
            return true;
          } else {
            return suportedImageFormats.includes(value.type);
          }
        }),
      nome: Yup.string()
        .trim()
        .when("nomeSocial", {
          is: (nomeSocial) => !nomeSocial || nomeSocial.trim() === "",
          then: Yup.string().required("Este campo é obrigatório!"),
          otherwise: Yup.string(),
        }),
      nomeSocial: Yup.string()
        .trim()
        .when("nomeNaoInformado", {
          is: (nomeNaoInformado) =>
            nomeNaoInformado && nomeNaoInformado.length > 0,
          then: Yup.string().required("Este campo é obrigatório!"),
          otherwise: Yup.string(),
        }),

      idGenero: Yup.object().nullable().required("Este campo é obrigatório!"),
      dataNascimento: Yup.string("Este campo é obrigatório!")
        .nullable()
        .required("Este campo é obrigatório!")
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .when("filiacoes", {
          is: (filiacoes) => {
            return filiacoes.length > 0;
          },
          then: (schema) => {
            return schema.when("filiacoes", (filiacoes, schema) => {
              return schema
                .test(
                  "dataNascimentoAfterFiliacao",
                  "A data informada não pode ser uma data anterior ao nascimento de uma filiação!",
                  (value) => {
                    if (!value) {
                      return true;
                    } else {
                      const found = filiacoes.find((filiacao) => {
                        if (filiacao.dataNascimento) {
                          return isBefore(
                            parse(value, "dd/MM/yyyy", new Date()),
                            parse(
                              filiacao.dataNascimento,
                              "dd/MM/yyyy",
                              new Date()
                            )
                          );
                        } else {
                          return false;
                        }
                      });
                      if (found) {
                        return false;
                      } else {
                        return true;
                      }
                    }
                  }
                )
                .test(
                  "dataNascimentoEqualFiliacao",
                  "A data informada não pode ser igual ao nascimento de uma filiação!",
                  (value) => {
                    if (!value) {
                      return true;
                    } else {
                      const found = filiacoes.find((filiacao) => {
                        if (filiacao.dataNascimento) {
                          return isEqual(
                            parse(
                              filiacao.dataNascimento,
                              "dd/MM/yyyy",
                              new Date()
                            ),
                            parse(value, "dd/MM/yyyy", new Date())
                          );
                        } else {
                          return false;
                        }
                      });
                      if (found) {
                        return false;
                      } else {
                        return true;
                      }
                    }
                  }
                );
            });
          },
        }),
      dataFoto: Yup.string()
        .nullable()
        .test(
          "dataFotoAfterToday",
          "A data informada não pode ser uma data futura!",
          (value) => {
            if (value === null) {
              return false;
            } else {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date()
              );
            }
          }
        )
        .test("notBeforeBirthDate", "", function (value) {
          const { dataNascimento } = this.parent;
          const dataFoto = parse(value, "dd/MM/yyyy", new Date());

          if (value && dataNascimento) {
            if (
              isValid(dataFoto) &&
              isValid(parse(dataNascimento, "dd/MM/yyyy", new Date()))
            ) {
              return !isBefore(
                dataFoto,
                parse(dataNascimento, "dd/MM/yyyy", new Date())
              );
            } else {
              return false;
            }
          } else {
            return true;
          }
        })

        .when("foto", {
          is: (fotoPresente) => !!fotoPresente,
          then: Yup.string()
            .required("Este campo é obrigatório!")
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          otherwise: Yup.string().test(
            "validDate",
            "Data inválida!",
            (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return true;
              }
            }
          ),
        }),
      nomeNaoInformado: Yup.array().test(
        "naoInformado",
        "Este campo é obrigatório!",
        function (value) {
          const { nomeSocial, nome } = this.parent;
          if (!nome && nomeSocial) {
            return value.length > 0;
          }
          return true;
        }
      ),
      idRaca: Yup.object().nullable().required("Este campo é obrigatório!"),
      idNacionalidade: Yup.mixed(),
      idNaturalidade: Yup.mixed(),
      idTipoSanguineo: Yup.mixed(),
      filiacoes: Yup.array()
        .max(4, "Máx. 4 filiações")
        .test("isEmpty", "Este campo é obrigatório!", (value) => {
          return !!value.length;
        })
        .test("hasPai", "Este campo é obrigatório!", (value) => {
          if (value.length) {
            const filiacaoPai = value.find(
              (filiacao) => filiacao.tipoFiliacao === "Pai"
            );
            if (!!filiacaoPai) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test("hasMae", "Este campo é obrigatório!", (value) => {
          if (value.length) {
            const filiacaoPai = value.find(
              (filiacao) => filiacao.tipoFiliacao === "Mãe"
            );
            if (!!filiacaoPai) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }),
      dataMovimentacao: Yup.string("Este campo é obrigatório!")
        .nullable()
        .required("Este campo é obrigatório!")
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test("dataMovimentacaoAfterToday", "", (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .test("notBeforeBirthDate", "", function (value) {
          const { dataNascimento } = this.parent;
          const dataMovimentacao = parse(value, "dd/MM/yyyy", new Date());

          if (
            isValid(dataMovimentacao) &&
            isValid(parse(dataNascimento, "dd/MM/yyyy", new Date()))
          ) {
            return !isBefore(
              dataMovimentacao,
              parse(dataNascimento, "dd/MM/yyyy", new Date())
            );
          } else {
            return false;
          }
        }),
      idServicoAcolhimento: Yup.object()
        .nullable()
        .required("Este campo é obrigatório!"),
      idMotivoSituacao: Yup.object()
        .nullable()
        .required("Este campo é obrigatório!"),
      incluidoProgramaPPCAAM: Yup.object()
        .nullable()
        .when("idMotivoSituacao", {
          is: (motivo) => motivo && motivo.riscoVida === "S",
          then: Yup.object().required("Este campo é obrigatório!"),
        }),
      numeroGuia: Yup.string().when(["anexoGuia"], {
        is: (anexo) => anexo,
        then: Yup.string().required("Este campo é obrigatório!"),
        otherwise: Yup.string(),
      }),
      anexoGuia: Yup.mixed()
        .nullable()
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (value === null) {
            return true;
          } else {
            return value.size <= 10000000;
          }
        })
        .test("fileType", "Anexar uma extensão válida.", (value) => {
          if (value === null) {
            return true;
          } else {
            let haveFormat = false;
            suportedFormats.forEach((format) => {
              if (value.path.toString().toLowerCase().includes(format)) {
                haveFormat = true;
              }
            });
            return haveFormat;
          }
        }),
      informacoesComplementares: Yup.string(),

      cpfFamiliaAcolhedora: Yup.string().when(
        "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        {
          is: (regime) => regime === "SAF",
          then: Yup.string()
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!")

            .test("cpfValido", "", (value) => {
              if (value && !isValidCPF(value)) {
                return false;
              } else {
                return true;
              }
            })
            .test("messageValid", "", () => {
              if (messageValid) {
                return false;
              } else {
                return true;
              }
            }),
        }
      ),

      nomeFamiliaAcolhedora: Yup.string().when(
        "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        {
          is: (regime) => regime === "SAF",
          then: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
        }
      ),

      dataValidadeTermoGuarda: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (value && value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else if (value && value.length !== 10) {
            return false;
          }

          return true;
        }),

      dataNascimentoFamiliaAcolhedora: Yup.string()
        .when("idServicoAcolhimento.tipoServicoAcolhimento.regime", {
          is: (regime) => regime === "SAF",
          then: Yup.string("Este campo é obrigatório!")
            .nullable()
            .required("Este campo é obrigatório!")
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
        })
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }),

      idBairroFamiliaAcolhedora: Yup.object().when(
        "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        {
          is: (regime) => regime === "SAF",
          then: Yup.object().nullable().required("Este campo é obrigatório!"),
          otherwise: Yup.object().nullable(),
        }
      ),

      idGeneroFamiliaAcolhedora: Yup.object().when(
        "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        {
          is: (regime) => regime === "SAF",
          then: Yup.object().nullable().required("Este campo é obrigatório!"),
          otherwise: Yup.object().nullable(),
        }
      ),

      anexoTermoGuardaFamiliaAcolhedora: Yup.mixed().when(
        "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        {
          is: (regime) => regime === "SAF",
          then: Yup.mixed()
            .nullable()
            .when(["dataValidadeTermoGuarda"], {
              is: (dataValidade) => dataValidade,
              then: Yup.mixed().required("Este campo é obrigatório!"),
            })
            .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
              if (value === null) {
                return true;
              } else {
                return value.size <= 10000000;
              }
            })
            .test("fileType", "Anexar uma extensão válida.", (value) => {
              if (value === null) {
                return true;
              } else {
                let haveFormat = false;
                suportedFormats.forEach((format) => {
                  if (value.path.toString().toLowerCase().includes(format)) {
                    haveFormat = true;
                  }
                });
                return haveFormat;
              }
            }),
          otherwise: Yup.mixed().nullable(),
        }
      ),
    },
    [["nome", "nomeSocial"]]
  );

  const adicionarFoto = async (id, foto, dataFoto, idAnexoFoto) => {
    try {
      await CriancaService.postFotoCriancaPerfil(
        id,
        foto,
        dataFoto,
        idAnexoFoto
      );
    } catch (error) {
      console.error("Erro ao adicionar foto da Crianca:", error);
    }
  };

  const adicionarAnexo = async (id, idCrianca, anexo) => {
    try {
      await MovimentacaoService.postAnexoMovimentacaoAcolhimento(
        id,
        idCrianca,
        anexo
      );
    } catch (error) {
      console.error("Erro ao adicionar Anexo Guia:", error);
    }
  };

  const adicionarAnexoTermoGuarda = async (
    idSA,
    idCrianca,
    anexo,
    timesTamp,
    cpf
  ) => {
    try {
      await FamiliaAcolhedoraSAService.postFamiliaAcolhedoraTermoGuarda(
        idSA,
        idCrianca,
        anexo,
        timesTamp,
        cpf
      );
    } catch (error) {
      console.error("Erro ao adicionar Termo de guarda:", error);
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(async () => {
      const {
        foto,
        nome,
        dataFoto,
        nomeFicticio,
        nomeNaoInformado,
        nomeSocial,
        idGenero,
        dataNascimento,
        dataNascimentoEstimada,
        idRaca,
        idNacionalidade,
        idNaturalidade,
        idTipoSanguineo,
        filiacoes,
        dataMovimentacao,
        idServicoAcolhimento,
        idMotivoSituacao,
        incluidoProgramaPPCAAM,
        numeroGuia,
        anexoGuia,

        informacoesComplementares,
        tipoMotivoSituacao,

        cpfFamiliaAcolhedora,
        nomeFamiliaAcolhedora,
        idGeneroFamiliaAcolhedora,
        idBairroFamiliaAcolhedora,
        dataNascimentoFamiliaAcolhedora,
        dataValidadeTermoGuarda,
        anexoTermoGuardaFamiliaAcolhedora,
      } = values;
      const isFamiliaAcolhedora =
        idServicoAcolhimento.tipoServicoAcolhimento.regime === "SAF";

      const filiacoesTemp = await Promise.all(
        filiacoes.map(async (filiacao) => {
          const nameImage = filiacao?.arquivoBase64?.name;
          const typeImage = filiacao?.arquivoBase64?.type;

          if (filiacao.arquivoBase64 instanceof File) {
            await new Promise((resolve) => {
              getBase64(filiacao.arquivoBase64, (base64Data) => {
                filiacao.arquivoBase64 = base64Data;
                resolve();
              });
            });
          }

          const anexoCertidaoObito = {
            arquivoBase64: filiacao?.arquivoBase64
              ? filiacao?.arquivoBase64.split(",")[1]
              : filiacao?.possuiAnexoCertidaoObito && filiacao?.removeu
              ? filiacao?.certidaoObito?.arquivoBase64.split(",")[1]
              : "",
            arquivoNome: nameImage ? nameImage : "",
            arquivoTipo: typeImage ? typeImage : "",
            idAnexo: !filiacao?.possuiAnexoCertidaoObito
              ? 0
              : filiacao?.possuiAnexoCertidaoObito && filiacao?.removeu
              ? filiacao?.certidaoObito?.idAnexo
              : filiacao?.possuiAnexoCertidaoObito && !filiacao?.removeu
              ? filiacao?.certidaoObito?.idAnexo
              : 0,
          };

          const isFalecido =
            filiacao?.falecido === "S" || filiacao?.falecido?.id === 1;
          const naoFalecido =
            !filiacao?.falecido ||
            filiacao?.falecido === "N" ||
            filiacao?.falecido?.id === 2;

          if (filiacao?.arquivoBase64 && isFalecido) {
            anexoCertidaoObito.remover = false;
            anexoCertidaoObito.atualizar = true;
          } else if (
            filiacao?.possuiAnexoCertidaoObito &&
            isFalecido &&
            filiacao?.removeu &&
            !filiacao?.arquivoBase64
          ) {
            anexoCertidaoObito.remover = true;
            anexoCertidaoObito.atualizar = true;
          } else if (filiacao?.possuiAnexoCertidaoObito && naoFalecido) {
            anexoCertidaoObito.arquivoBase64 = "";
            anexoCertidaoObito.remover = true;
            anexoCertidaoObito.atualizar = true;
          } else {
            anexoCertidaoObito.remover = false;
            anexoCertidaoObito.atualizar = false;
          }

          if (filiacao.local) {
            const {
              id,
              local,
              tipoFiliacao,
              nome,
              dataNascimento,
              falecido,
              cpf,
              numeroIdentidade,
              email,
              informacoesComplementares,
              idEstado,
              idMunicipio,
              idBairro,
              logradouro,
              complemento,
              pontoReferencia,
              ...resto
            } = filiacao;

            const returnObject = {
              anexoCertidaoObito: anexoCertidaoObito ? anexoCertidaoObito : "",
              tipoFiliacao: tipoFiliacao ? tipoFiliacao : "",
              nome: nome ? nome.trim() : "",
              dataNascimento: dataNascimento
                ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
                : "",
              falecido: falecido === "S" ? "S" : falecido === "N" ? "N" : null,
              cpf: cpf ? cpf.replace(/[.-]|[.-](?=.)/g, "").trim() : "",
              numeroIdentidade: numeroIdentidade ? numeroIdentidade.trim() : "",
              email: email ? email.trim() : "",
              informacoesComplementares: informacoesComplementares
                ? informacoesComplementares.trim()
                : "",
              idEstado: idEstado ? idEstado.id : "",
              idMunicipio: idMunicipio ? idMunicipio.id : "",
              idBairro: idBairro ? idBairro.id : "",
              logradouro: logradouro ? logradouro.trim() : "",
              complemento: complemento ? complemento.trim() : "",
              pontoReferencia: pontoReferencia ? pontoReferencia.trim() : "",
              ...resto,
            };

            delete returnObject.arquivoBase64;
            delete returnObject.possuiAnexoCertidaoObito;
            delete returnObject.removeu;
            delete returnObject.certidaoObito;
            return returnObject;
          } else {
            const returnObject = {
              ...filiacao,
              anexoCertidaoObito: anexoCertidaoObito ? anexoCertidaoObito : "",
              idEstado: filiacao.idEstado
                ? filiacao.idEstado.id
                : filiacao.estado
                ? filiacao.estado.id
                : "",
              idMunicipio: filiacao.idMunicipio
                ? filiacao.idMunicipio.id
                : filiacao.municipio
                ? filiacao.municipio.id
                : "",
              idBairro: filiacao.idBairro
                ? filiacao.idBairro.id
                : filiacao.bairro
                ? filiacao.bairro.id
                : "",
              falecido:
                filiacao.falecido === "S"
                  ? "S"
                  : filiacao.falecido === "N"
                  ? "N"
                  : null,
              dataNascimento: filiacao.dataNascimento
                ? isValid(filiacao.dataNascimento)
                  ? new Date(filiacao.dataNascimento).toISOString()
                  : parse(
                      filiacao.dataNascimento,
                      "dd/MM/yyyy",
                      new Date()
                    ).toISOString()
                : "",
            };
            delete returnObject.arquivoBase64;
            delete returnObject.possuiAnexoCertidaoObito;
            delete returnObject.removeu;
            delete returnObject.certidaoObito;
            return returnObject;
          }
        })
      );
      const valuesToSend = {
        crianca: {
          nome: nome ? nome.trim() : "",
          nomeFicticio: nomeFicticio.includes("Possui") ? "S" : "N",
          nomeNaoInformado: nomeNaoInformado.includes("Possui") ? "S" : "N",
          nomeSocial: nomeSocial ? nomeSocial.trim() : "",
          idGenero: idGenero ? idGenero.id : "",
          dataNascimento: dataNascimento
            ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
            : "",
          dataNascimentoEstimada: dataNascimentoEstimada.includes("Possui")
            ? "S"
            : "N",
          idRaca: idRaca ? idRaca.id : "",
          idNacionalidade: idNacionalidade ? idNacionalidade.id : "",
          idNaturalidade: idNaturalidade ? idNaturalidade.id : "",
          idTipoSanguineo: idTipoSanguineo ? idTipoSanguineo.id : "",
          idServicoAcolhimento: idServicoAcolhimento
            ? idServicoAcolhimento.id
            : "",
          nomeUsuarioLogado: `${
            !!keycloak.user.profile?.name ? keycloak.user.profile?.name : ""
          }`,
          idPessoaFisicaFilho: idPessoaFisicaFilho ? idPessoaFisicaFilho : null,
        },

        filiacoes: filiacoesTemp,
        movimentacao: {
          dataMovimentacao: dataMovimentacao
            ? parse(dataMovimentacao, "dd/MM/yyyy", new Date()).toISOString()
            : "",
          idServicoAcolhimento: idServicoAcolhimento
            ? idServicoAcolhimento.id
            : "",
          tipoMotivoSituacao: tipoMotivoSituacao
            ? tipoMotivoSituacao.value
            : "",
          idMotivoSituacao: idMotivoSituacao ? idMotivoSituacao.id : "",
          incluidoProgramaPPCAAM: incluidoProgramaPPCAAM
            ? incluidoProgramaPPCAAM.value
            : "",
          numeroGuia: numeroGuia ? numeroGuia.trim() : "",
          informacoesComplementares: informacoesComplementares
            ? informacoesComplementares.trim()
            : "",
        },
        familiaAcolhedora: {
          cpfAcolhedor:
            cpfFamiliaAcolhedora && isFamiliaAcolhedora
              ? cpfFamiliaAcolhedora.replace(/[.-]|[.-](?=.)/g, "").trim()
              : "",
          nome:
            nomeFamiliaAcolhedora && isFamiliaAcolhedora
              ? nomeFamiliaAcolhedora.trim()
              : "",
          dataNascimento:
            dataNascimentoFamiliaAcolhedora && isFamiliaAcolhedora
              ? parse(
                  dataNascimentoFamiliaAcolhedora,
                  "dd/MM/yyyy",
                  new Date()
                ).toISOString()
              : "",
          idGenero:
            idGeneroFamiliaAcolhedora && isFamiliaAcolhedora
              ? idGeneroFamiliaAcolhedora.id
              : "",
          idBairro:
            idBairroFamiliaAcolhedora && isFamiliaAcolhedora
              ? idBairroFamiliaAcolhedora.id
              : "",
          dataValidadeTermoGuarda:
            dataValidadeTermoGuarda && isFamiliaAcolhedora
              ? parse(
                  dataValidadeTermoGuarda,
                  "dd/MM/yyyy",
                  new Date()
                ).toISOString()
              : "",
        },
      };

      const Imagens = {
        foto: foto ? foto : "",
        anexoGuia: anexoGuia ? anexoGuia : "",
        anexoTermoGuardaFamiliaAcolhedora: anexoTermoGuardaFamiliaAcolhedora
          ? anexoTermoGuardaFamiliaAcolhedora
          : "",
      };

      CriancaService.novoCrianca(valuesToSend)
        .then((res) => {
          const { id, movimentacoes } = res.data;

          if (id) {
            if (Imagens.foto) {
              adicionarFoto(
                id,
                Imagens.foto,
                format(parse(dataFoto, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
                0
              );
            }

            if (Imagens.anexoGuia) {
              adicionarAnexo(movimentacoes[0].id, id, Imagens.anexoGuia);
            }

            if (Imagens.anexoTermoGuardaFamiliaAcolhedora) {
              const dataValidadeTermoGuarda =
                valuesToSend.familiaAcolhedora.dataValidadeTermoGuarda;
              const parsedDataValidadeTermoGuarda = dataValidadeTermoGuarda
                ? Date.parse(dataValidadeTermoGuarda)
                : "";

              adicionarAnexoTermoGuarda(
                valuesToSend.movimentacao.idServicoAcolhimento,
                id,
                Imagens.anexoTermoGuardaFamiliaAcolhedora,

                parsedDataValidadeTermoGuarda,
                valuesToSend.familiaAcolhedora.cpfAcolhedor
              );
            }
          }
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.push("/crianca/" + id);
          });
        })
        .catch((error) => {
          if (error.response) {
            if (
              error.response.data.field === "criancaDTO" &&
              error.response.status === 400
            ) {
              Swal.fire({
                title: "Atenção!",
                html: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "warning",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            }
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "criancaDTO") {
                  Swal.fire({
                    title: "Atenção!",
                    html: error.response.data.message
                      ? error.response.data.message
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(
                      erro.field
                        .toString()
                        .slice(erro.field.toString().indexOf(".") + 1),
                      erro.message
                    );
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
        });

      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={{ base: "10px", lg: "32px" }}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Flex
        pt="4px"
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
        w="100%"
      >
        <Text
          color="#252733"
          fontWeight={700}
          fontSize="24px"
          lineHeight="29.05px"
        >
          Cadastrar Dados Principais
        </Text>
        <Button
          color="#FFF"
          backgroundColor="#169499"
          fontWeight={700}
          fontSize="15px"
          lineHeight="21.6px"
          _hover={{ bg: "#169499" }}
          onClick={backAlert}
          px="45px"
          h="42px"
        >
          Voltar
        </Button>
      </Flex>
      {roleKeycloack.includes(criancaFunc.cadastrar) ? (
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={{
              foto: null,
              nome: "",
              nomeFicticio: [],
              nomeNaoInformado: [],
              dataFoto: "",
              nomeSocial: "",
              idGenero: "",
              dataNascimento: "",
              dataNascimentoEstimada: [],
              idRaca: "",
              idNacionalidade: "",
              idNaturalidade: "",
              idTipoSanguineo: "",
              filiacoes: [],
              situacaoMae: "",
              situacaoPai: "",
              dataMovimentacao: "",
              tipoMotivoSituacao: { label: "Acolhido", value: "Acolhido" },
              idServicoAcolhimento: "",
              incluidoProgramaPPCAAM: "",
              idMotivoSituacao: "",
              programa: "",
              numeroGuia: "",
              anexoGuia: null,
              arquivoBase64: null,
              idPessoaFisicaFilho: idPessoaFisicaFilho
                ? idPessoaFisicaFilho
                : null,
              nomeUsuarioLogado: `${
                !!keycloak.user.profile?.name ? keycloak.user.profile?.name : ""
              }`,
              informacoesComplementares: "",

              cpfFamiliaAcolhedora: "",
              nomeFamiliaAcolhedora: "",
              dataNascimentoFamiliaAcolhedora: "",
              idGeneroFamiliaAcolhedora: "",
              idBairroFamiliaAcolhedora: "",
              dataValidadeTermoGuarda: "",
              anexoTermoGuardaFamiliaAcolhedora: null,
            }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(props) => (
              <Form onKeyDown={onKeyDown}>
                <FocusError />

                <FocusErrorData />
                <FocusErrorDuplicidade />
                <Identificacao
                  props={props}
                  dataFuturaFoto={dataFuturaFoto}
                  dataMenorFoto={dataMenorFoto}
                  removeu={removeu}
                  setRemoveu={setRemoveu}
                />
                <Field name={"filiacoes"}>
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.filiacoes && form.touched.filiacoes
                      }
                      id={"filiacoes"}
                    >
                      <Filiacao
                        filiacoes={props.values.filiacoes}
                        idCrianca={id}
                      />
                      <FormErrorMessage>
                        {form.errors.filiacoes}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Movimentacao
                  props={props}
                  dataMenor={dataMenor}
                  dataFutura={dataFutura}
                  dataNascimento={props.values.dataNascimento}
                  roleKeycloack={roleKeycloack}
                  user={user}
                />
                {(props.values.idServicoAcolhimento
                  ? props.values.idServicoAcolhimento.tipoServicoAcolhimento
                      .regime === "SAF"
                  : false) && (
                  <FamiliaAcolhedora
                    props={props}
                    invalidCPF={invalidCPF}
                    messageValid={messageValid}
                    setMessageValid={setMessageValid}
                    dataNascimentoFuturaFamilia={dataNascimentoFuturaFamilia}
                  />
                )}

                <Flex justifyContent="flex-end">
                  <Button
                    type="submit"
                    translate="no"
                    mt="30px"
                    px="45px"
                    h="42px"
                    color="#FFF"
                    backgroundColor="#169499"
                    fontWeight={700}
                    fontSize="15px"
                    lineHeight="21.6px"
                    _hover={{ bg: "#169499" }}
                    isLoading={props.isSubmitting}
                  >
                    Salvar
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      ) : (
        <Box mt={4} w={"100%"}>
          <SemRegistros buttonVisible={true} />
        </Box>
      )}
    </Flex>
  );
};
